import { TableColumn } from '@shared';
import { COLORS } from '@shared/constants';

export const DEALERS_TABLE_COLUMNS: TableColumn[] = [
    {
        field: 'dealerAlias',
        header: 'Dealer Alias',
        width: '300px',
        hasRedirect: true,
    },
    {
        field: 'businessName',
        header: 'Business Name',
        width: '300px',
    },
    { field: 'contactPerson', header: 'Contact Person', width: '200px' },
    { field: 'status', header: 'Status', width: '300px' },
    {
        field: 'actions',
        header: 'Actions',
        type: 'actions',
        maxWidth: '100px',
        width: '40px',

        actions: [
            {
                name: 'Delete',
                icon: 'outline-trash',
                size: 12,
                hightlighLabel: true,
                color: COLORS.danger,
            },
        ],
    },
];
